import React, { useState } from 'react';
import { ArrowUpRight, Copy, Check } from 'lucide-react';
import { EMAIL, SOCIALS, CONTACT_COPY } from '../mock';

export default function Contact() {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(EMAIL);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch (e) {
      // no-op
    }
  };

  return (
    <section id="contact" className="py-28 md:py-40">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="mono text-[11px] uppercase tracking-[0.2em] mb-10" style={{ color: 'var(--terracotta)' }}>
          § 05 · Say hi
        </div>

        <div className="grid md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-8">
            <h2
              className="display"
              style={{
                fontSize: 'clamp(2.25rem, 6vw, 5rem)',
                lineHeight: 0.98,
                fontWeight: 400,
                color: 'var(--ink)',
              }}
            >
              Building something{' '}
              <em className="italic serif" style={{ color: 'var(--forest)' }}>early</em>{' '}
              and{' '}
              <em className="italic serif" style={{ color: 'var(--terracotta)' }}>real</em>?
            </h2>
            <p className="mt-8 text-[15px] md:text-[17px] leading-relaxed max-w-2xl" style={{ color: 'var(--forest-soft)' }}>
              {CONTACT_COPY.body}
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-3">
              <a
                href={`mailto:${EMAIL}?subject=Hey%20Sirin`}
                className="inline-flex items-center gap-2 px-5 py-3 rounded-full mono text-[12px] uppercase tracking-[0.16em]"
                style={{ background: 'var(--forest)', color: 'var(--cream)' }}
                onMouseEnter={(e) => { e.currentTarget.style.background = 'var(--ink)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = 'var(--forest)'; }}
              >
                Write me <ArrowUpRight size={14} />
              </a>
              <button
                onClick={handleCopy}
                className="inline-flex items-center gap-2 px-5 py-3 rounded-full mono text-[12px] uppercase tracking-[0.16em]"
                style={{
                  background: 'transparent',
                  color: 'var(--ink)',
                  border: '1px solid rgba(15,27,20,0.2)',
                }}
              >
                {copied ? <Check size={14} /> : <Copy size={14} />}
                {copied ? 'Copied' : EMAIL}
              </button>
            </div>
          </div>

          <div className="md:col-span-4 md:col-start-9">
            <div className="mono text-[11px] uppercase tracking-[0.2em] mb-5" style={{ color: 'var(--moss)' }}>
              Elsewhere
            </div>
            <ul className="space-y-4">
              {SOCIALS.map((s) => (
                <li key={s.label}>
                  <a
                    href={s.href}
                    target={s.href.startsWith('http') ? '_blank' : undefined}
                    rel="noopener noreferrer"
                    className="group flex items-center justify-between py-3 border-b"
                    style={{ borderColor: 'rgba(15,27,20,0.12)' }}
                  >
                    <div>
                      <div className="mono text-[10px] uppercase tracking-[0.2em]" style={{ color: 'var(--stone)' }}>
                        {s.label}
                      </div>
                      <div className="text-[15px]" style={{ color: 'var(--ink)' }}>
                        {s.handle}
                      </div>
                    </div>
                    <ArrowUpRight size={16} style={{ color: 'var(--forest)' }} />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
